// axios
import axios from 'axios'
import { clearSession } from '@/utils/session'
import Vue from 'vue'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 300000000,
})

axiosIns.interceptors.request.use(
  config => {
    // Do something before request is sent

    const accessToken = localStorage.getItem('accessToken')

    // eslint-disable-next-line no-param-reassign
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`

    return config
  },
  error => Promise.reject(error),
)

// Add a response interceptor
axiosIns.interceptors.response.use(
  response => {
    // API her zaman JSON nesnesi döner. String gelirse (ör. PHP "Fatal error" HTML çıktısı, HTTP 200 ile)
    // `response.data.error` undefined kalıp istek başarılı sanılıyordu; bunun yerine hata olarak reddet.
    if (typeof response.data === 'string') {
      const method = String(response.config?.data || '').match(/method=([^&]+)/)?.[1]
      console.error('Geçersiz API yanıtı:', method || response.config?.url)
      const err = new Error('Sunucudan geçersiz yanıt alındı, lütfen daha sonra tekrar deneyin.')
      err.isInvalidResponse = true
      err.response = response

      return Promise.reject(err)
    }

    if (response.data.error == 99) {
      clearSession()
      window.location.href = '/'
    }

    return response
  },
  error =>
    // localStorage.removeItem('accessToken')
    // localStorage.removeItem('userData')
    // localStorage.removeItem('userAbility')
    // window.location.href = '/'
    // Do something with response error
    Promise.reject(error),
)

Vue.prototype.$http = axiosIns

export default axiosIns
